import { AccountTypes } from '@interfaces/models';
import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromSelectedInternalTransferState from '../../reducers/internal-transfer/internal-transfer.reducer';

export const selectInternalTransferState = createSelector(
  fromFeature.getInternalTransferState,
  (state) => state,
);

export const selectInternalTransferTriage = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferTriage,
);

export const selectInternalTransferFrom = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferFrom,
);

export const selectInternalTransferAccountFrom = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferAccountFrom,
);

export const selectInternalTransferFromAccountType = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferFromAccountType,
);

export const selectInternalTransferToAccountType = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferToAccountType,
);

export const selectInternalTransferTo = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferTo,
);

export const selectInternalTransferAccountTo = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferAccountTo,
);

export const selectTransferMethod = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferMethod,
);

export const selectTransferType = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferType,
);

export const selectInternalTransferIsOwner = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferIsOwner,
);

export const selectInternalTransferIsTransferConditionMatch = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferIsTransferConditionMatch,
);

export const selectInternalTransferIsDivorceTransfer = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferIsDivorceTransfer,
);

export const selectInternalTransferHasAvgCostHoldings = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferHasAvgCostHoldings,
);

export const selectInternalTransferTotalTransferValue = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferTotalTransferValue,
);

export const selectInternalTransferConvertSpecIDHoldings = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferConvertSpecIDHoldings,
);

export const selectInternalTransferConvertAvgCostHoldings = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferConvertAvgCostHoldings,
);

export const selectInternalTransferTransactionType = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferTransactionType,
);

export const selectInternalTransferTransferId = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferId,
);

export const selectInternalTransferSignerState = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferSignerState,
);

export const selectInternalTransferPercentageOfHoldings = createSelector(
  selectInternalTransferState,
  fromSelectedInternalTransferState.getInternalTransferPercentageOfHoldings,
);

export const selectIsMinorGift = createSelector(
  selectInternalTransferFromAccountType,
  selectInternalTransferToAccountType,
  (from, to) => {
    return from !== AccountTypes.ESTATE && to === AccountTypes.UGMA_UTMA;
  },
);

export const selectITSummaryStepsVisible = createSelector(
  selectInternalTransferTriage,
  selectIsMinorGift,
  selectInternalTransferIsDivorceTransfer,
  selectInternalTransferIsTransferConditionMatch,
  (triage, isMinorGift, isDivorceTransfer, isTransferConditionsAffirmed) => {
    const visible =
      (triage?.exceptionsApply ||
        triage?.transferFrom === 'ESTATE' ||
        !!triage?.isOwner ||
        isDivorceTransfer ||
        isTransferConditionsAffirmed) &&
      triage.transferTo !== 'ESTATE' &&
      !isMinorGift;
    return !!visible;
  },
);
